<template>
    <div
        :class="[
            variants[variant].wrapperClasses,
        ]"
        class="relative rounded-sm border border-gray-light"
    >
        <input
            @change="valueChange"
            type="radio"
            :aria-label="label"
            :title="label"
            :checked="isChecked"
            :name="inputName"
            :value="inputValue"
            :disabled="isDisabled"
            :style="variants[variant].backgroundStyles"
            :class="[
                variants[variant].backgroundClasses,
                { 'cursor-not-allowed': isDisabled },
            ]"
            class="w-full h-full bg-cover"
        >

        <img
            v-if="isChecked"
            src="../assets/images/icons/check-green.svg"
            width="24"
            height="24"
            alt="check mark"
            :class="[ variant === 'small' ? 'm-auto inset-0' : 'top-3 right-3' ]"
            class="absolute pointer-events-none"
        >

        <span v-if="isDebugMode && debugValue"
            class="absolute right-0 top-0 inline-flex items-center rounded-full bg-red px-2 pt-1.5 pb-0 text-xs font-medium text-white pointer-events-none"
        >
            {{debugValue}}
        </span>

        <!-- Prevent image jumping -->
        <div
            v-if="isChecked"
            class="absolute pointer-events-none -left-[1px] -top-[1px] -right-[1px] -bottom-[1px] rounded-sm border-2 border-black">
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import { autoWebp } from '../helpers/images';

    export default {
        mixins: [allStores],

        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },
            selectedValue: {
                type: String,
                required: false,
            },
            inputName: {
                type: String,
                required: true,
            },
            inputValue: {
                type: String,
                required: true,
            },
            inputColor: {
                type: String,
                required: false,
            },
            inputImage: {
                type: String,
                required: false,
            },
            variant: {
                type: String,
                default: 'small',
            },
            label: {
                type: String,
            },
            debugValue: {
                type: String,
            },
        },

        computed: {
            isChecked() {
                return this.selectedValue === this.inputValue;
            },

            isDebugMode() {
                return this.customizerStore.options.debugMode;
            },

            variants() {
                return {
                    small: {
                        wrapperClasses: 'w-14 h-11',
                        backgroundStyles: {
                            backgroundColor: this.hexCode,
                            // Retina resolution at x2
                            backgroundImage: `url(${this.convertSwatch(autoWebp(`${this.inputImage}?rwid=112&rhei=88`))})`,
                        },
                        backgroundClasses: '',
                    },
                    medium: {
                        wrapperClasses: 'w-24 h-24 sm:w-28 sm:h-28',
                        backgroundStyles: {
                            backgroundImage: `url(${this.convertSwatch(autoWebp(this.inputImage))})`,
                        },
                        backgroundClasses: 'bg-cover bg-center bg-no-repeat',
                    },
                    large: {
                        wrapperClasses: 'w-36 h-36 sm:w-44 sm:h-44',
                        backgroundStyles: {
                            backgroundImage: `url(${this.convertSwatch(autoWebp(this.inputImage))}`,
                        },
                        backgroundClasses: 'bg-cover bg-center bg-no-repeat',
                    },
                };
            },

            hexCode() {
                if (this.inputColor) {
                    return this.inputColor.startsWith('#') ? this.inputColor : `#${this.inputColor}`;
                }

                return null;
            },
        },

        methods: {
            valueChange(event) {
                this.$emit('valueChange', event.srcElement.value);
            },

            convertSwatch(url) {
                return url; // url ? url.replace('Swatch', 'Swatch-v2') : url;
            },
        },
    };
</script>
